// @flow

import type { ExtractReturn } from '@ta/common.types';
import type { State as PageState } from '../page';

const emptyState = () => ({
  name: 'GEO',
  geoId: 0,
});

export type State = ExtractReturn<typeof emptyState>;

export default (state: PageState = emptyState()): PageState => state;
